import { STANDARD_ENV_OPTIONS, type EnvName } from '@/api/awsOrgProvisioning'

const ENV_SET = new Set<string>(STANDARD_ENV_OPTIONS)

/** Nó de OU, no mínimo que este helper precisa. */
interface NoDeOu {
  name: unknown
  /** Lápide do soft-delete: a OU não existe mais na AWS. */
  is_legacy?: boolean
}

/**
 * Ambientes padrão que têm OU **viva** entre os filhos.
 *
 * O espelho local guarda OU removida da AWS por decisão de desenho
 * (`aws_ou_tree_service` marca `is_legacy`, nunca apaga — o histórico importa).
 * Contá-la como "já provisionado" desabilitava o checkbox do ambiente que o
 * operador estava justamente tentando recriar. No sub-tenant Getnet isso
 * fechava os quatro, e o "Outro" também recusa nome padrão: sem saída.
 *
 * `is_legacy` ausente conta como **viva** — resposta antiga em cache do
 * navegador não pode fazer um ambiente sumir da lista de ocupados, senão o
 * operador criaria uma OU duplicada.
 */
export function envsVivos(filhos: NoDeOu[]): EnvName[] {
  return filhos
    .filter((c) => !c.is_legacy)
    .map((c) => String(c.name).toUpperCase())
    .filter((nome) => ENV_SET.has(nome)) as EnvName[]
}
